import { render, staticRenderFns } from "./delRulePop.vue?vue&type=template&id=31d50eb8"
import script from "./delRulePop.vue?vue&type=script&lang=js"
export * from "./delRulePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports